// Minimal API client. Swap baseURL via VITE_API_URL env at build time.
export interface ParcelFlag {
  folio: string;
  upzoneDelta: number | null;
  teardownScore: number | null;
  liveLocalFlag: boolean;
  opportunityScore: number | null;
  asOfDate: string;          // YYYY-MM-DD
  rulesetVersion: string;
  dataSource: string;
  ownerName?: string | null;
  yearBuilt?: number | null;
  address?: string | null;
  upcomingHearing?: { meetingDate: string; sourceUrl: string; body: string } | null;
}

export interface TopOpportunity {
  rank: number;
  parcel: ParcelFlag;
}

const BASE = import.meta.env.VITE_API_URL;

// When VITE_API_URL is unset we fall back to the static seed dataset
// shipped alongside the Pages build (apps/web/public/sample/*).
// Lets the demo work entirely on Cloudflare Pages without a backend.
const STATIC_TOP    = "/sample/opportunities.json";
const STATIC_PARCEL = (folio: string) => `/sample/parcel/${encodeURIComponent(folio)}.json`;

export async function fetchTop(limit = 50): Promise<TopOpportunity[]> {
  const url = BASE ? `${BASE}/api/opportunities?limit=${limit}` : STATIC_TOP;
  const r = await fetch(url);
  if (!r.ok) throw new Error(`API ${r.status}`);
  const j = await r.json();
  return Array.isArray(j) ? j.slice(0, limit) : j;
}

export async function fetchParcel(folio: string): Promise<ParcelFlag> {
  const url = BASE ? `${BASE}/api/parcel/${encodeURIComponent(folio)}` : STATIC_PARCEL(folio);
  const r = await fetch(url);
  if (!r.ok) throw new Error(`API ${r.status}`);
  // Guard against CF returning a 200 + HTML for unknown paths.
  const ct = r.headers.get("content-type") ?? "";
  if (!ct.includes("application/json")) {
    throw new Error(`Parcel ${folio} not in seed dataset`);
  }
  return r.json();
}
